export default __webpack_public_path__ + "static/media/AntyLucy_15.b7ee5de4.jpg";